/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/ArticleDate/theme';

export const ArticleDateTheme = theme;
